<div class="customers">
    <div>
        <div class="card-body">
            <div class="row" style="display: flex; justify-content: space-between; align-items: center;">
                <div class="separator" [ngClass]="'color-back-area-' + areaNumber" style="width: 100%; margin-left: 0px; margin-bottom: 10px; margin-right: -15px; display: flex; justify-content: space-between; align-items: center;">
                    <div class="estrategia-text">
                        <strong>{{subdimensionData.subDimension}}</strong>
                    </div>
                    <div class="estrategia-text" style="margin-left: auto; display: flex; align-items: center;">
                        <strong>Priorizada</strong>
                        <input type="checkbox" [checked]="subdimensionData.priorizada" *ngIf="subdimensionData.idSubDimensionPME === 5" style="margin-left: 5px;" disabled>
                        <input type="checkbox" [checked]="subdimensionData.priorizada" (change)="togglePriorizada(dimensionData, subdimensionData)" *ngIf="subdimensionData.idSubDimensionPME != 5" style="margin-left: 5px;" [disabled]="subdimensionData.disabledPriorizar">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="content" style="text-align: center;">OBJETIVO ESTRATÉGICO</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12" style="background-color: #E8EAF5;">
                    <textarea name="{{ 'objetivoTexto_' + indice }}" type="text" [(ngModel)]="subdimensionData.objetivo" class="text-area-objetivo"  [disabled]="subdimensionData.disabledObjetivo"></textarea>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 d-flex align-items-center" style="background-color: #E8EAF5;">
                    <p class="content text-meta-anio">META ANUAL 2024</p>
                </div>
                <div class="col-sm-9" style="background-color: #E8EAF5;">
                    <textarea name="meta1" type="text" class="text-area-meta-anio" [(ngModel)]="subdimensionData.meta1"  [disabled]="subdimensionData.disabledSiempre"></textarea>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 d-flex align-items-center" style="background-color: #E8EAF5;">
                    <p class="content text-meta-anio" >META ANUAL 2025</p>
                </div>
                <div class="col-sm-9" style="background-color: #E8EAF5;">
                    <textarea name="meta2" type="text" class="text-area-meta-anio" [(ngModel)]="subdimensionData.meta2" [disabled]="subdimensionData.disabledSiempre"></textarea>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 d-flex align-items-center" style="background-color: #E8EAF5;">
                    <p class="content text-meta-anio" >META ANUAL 2026</p>
                </div>
                <div class="col-sm-9" style="background-color: #E8EAF5;">
                    <textarea name="meta3" type="text" class="text-area-meta-anio" [(ngModel)]="subdimensionData.meta3"  [disabled]="subdimensionData.disabled2026"></textarea>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-3 d-flex align-items-center" style="background-color: #E8EAF5;">
                    <p class="content text-meta-anio" >META ANUAL 2027</p>
                </div>
                <div class="col-sm-9" style="background-color: #E8EAF5;">
                    <textarea name="meta4" type="text" class="text-area-meta-anio" [(ngModel)]="subdimensionData.meta4"   [disabled]="subdimensionData.disabledSiempre"></textarea>
                </div>
            </div>

        </div>
    </div>
</div>